import React, { Component } from "react";
import FormikLogin from "../../components/loginComponent/loginForm";
import qs from 'qs'
import $ from 'jquery';
import { Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { autoLogin } from "../../redux/actions/userAction";

class LoginView extends Component {

  state = {
    isAutoLogin: false,
    autoLoginText: 'Please wait...',
  }

  componentDidMount() {
    $('html').css('background-image', 'url(assets/img/loginpage.png)');
    $('html').css('background-size', 'cover');
    $('#loginView').css('background-image', 'url(assets/img/loginpage.png)');
    $('#loginView').css('background-size', 'cover');
    $('div').removeClass('main-panel');
    $('#sidebars').remove();
    $('.navigationMenu').remove();
    let queryString = qs.parse(window.location.search)
    let userKey = queryString["userKey"] || queryString["?userKey"] || null;
    let globalAccessToken = queryString["token"] || queryString["?token"] || null;
    if (userKey != null && globalAccessToken != null) {
      this.setState({
        isAutoLogin: true
      })
      this.props.autoLogin(globalAccessToken, userKey)
        .then((res) => {
          console.log('>>>>autologin res');
          console.log(JSON.stringify(res));
          localStorage.setItem('branchIds', res.branchIds);
          localStorage.setItem('billingpartbranchIds', res.billingPartyBranchIds);
          localStorage.setItem('billingpartIds', res.billingPartyIds);
          // if (res.customerNo == 1158 && res.role != "Vendor") {
          //   setTimeout(() => {
          //     window.location.href = "/shipment";
          // }, 500);
          // } else {
          setTimeout(() => {
            localStorage.getItem('role') == 'Vendor' ? window.location.href = "/active-orders" : window.location.href = "/shipment";
          }, 500);
          // }
        })
    }
  }
 
  render() {
    return (
      <React.Fragment>
        {!this.state.isAutoLogin ? <FormikLogin {...this.props} /> :
          <div className="loginView">
            <div className="container p-5">
              <div className="row">
                <div className="col-lg-5 offset-lg-3 col-10 offset-1 w3-white w3-card ">
                  <div className="row">
                    <div className="col-lg-12 p-5">
                      <Dimmer active inverted>
                        <Loader content={this.state.autoLoginText} />
                      </Dimmer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    autoLogin: (token, userKey) => dispatch(autoLogin(token, userKey))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);